<template lang="pug">
  v-container.pa-0
    v-card
      v-card-title
        h3 Build Info

      v-card-text
        p info back
        pre.app-info {{ backend_info }}
        p.mt-5 info front
        pre.app-info {{ frontend_info }}

</template>

<script>
import Urls from '@/router/urls'

export default {
  name: 'AppInfo',
  data () {
    return {
      backend_info: '{}',
      frontend_info: {
        /* global __BUILD_DATE__ */
        BuildDate: __BUILD_DATE__,
        /* global __COMMIT_HASH__ */
        GitHash: __COMMIT_HASH__,
        /* global __GIT_REMOTE__ */
        GitRemote: __GIT_REMOTE__,
      },
    }
  },
  mounted: function () {
    this.loadInfo()
  },
  methods: {
    loadInfo () {
      this.$axios
        .get(Urls.Dev.AppInfo)
        .then(response => {
          this.backend_info = response.data
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>
